import { createSelector } from "@reduxjs/toolkit";
import { getUserConfig } from "redux/User/selectors";
import { isFeatureEnabled } from "helpers/utility/utilities";
import {
  ADD_MEDIA,
  DELETE_DATASET,
  USAGE_REPORT,
} from "helpers/constants/filters";
import { EnrichingDS, InventoryFilterData } from "types";

const state = (state: any) => state.datasets;

export const getLoading = createSelector(state, (state: any) => {
  return state.isLoading;
});

export const getContentLoading = createSelector(state, (state: any) => {
  return state.isContentLoading;
});

export const getDatasets = createSelector(state, (state: any) => {
  return state.datasets;
});

export const getSampleData = createSelector(state, (state: any) => {
  return state.sampleData;
});

export const getDatasetId = createSelector(state, (state: any) => {
  return state.datasetId;
});

export const getSelectedSampleDataset = createSelector(state, (state: any) => {
  return state.selectedSampleDataset;
});

export const getIsError = createSelector(state, (state: any) => {
  return state.isError;
});

export const getErrorText = createSelector(state, (state: any) => {
  return state.errorText;
});

export const getSampleDataset = createSelector(state, (state: any) => {
  return state.dataset;
});

export const getLimitError = createSelector(state, (state: any) => {
  return state.limitError;
});

export const getDeleteModalId = createSelector(state, (state: any) => {
  return state.deleteModalId;
});

export const getHealthStatus = createSelector(state, (state: any) => {
  return state.healthStatus;
});

export const getIsDisclaimerShown = createSelector(state, (state: any) => {
  return state.isDisclaimerShown;
});

export const getIsPublicPath = createSelector(state, (state: any) => {
  return state.isPublicPath;
});

export const getSelectedExportIDs = createSelector(state, (state: any) => {
  return state.selectedExportIDs;
});

export const getSelectedImageCount = createSelector(state, (state: any) => {
  return state.selectedImageCount;
});

export const getDatasetToDuplicate = createSelector(state, (state: any) => {
  return state.datasets?.find(
    (ds: any) => ds.id === state.datasetIdToDuplicate,
  );
});

export const getIsUsageReportEnabled = createSelector(
  getUserConfig,
  (userConfig: any): boolean => {
    return isFeatureEnabled(userConfig, USAGE_REPORT);
  },
);

export const getIsDeleteDatasetEnabled = createSelector(
  getUserConfig,
  (userConfig: any): boolean => {
    return isFeatureEnabled(userConfig, DELETE_DATASET);
  },
);

export const getEnrichingDataset = createSelector(
  state,
  (state): null | EnrichingDS => {
    return state.enrichingDataset;
  },
);

export const getFilterData = createSelector(
  state,
  (state): InventoryFilterData => {
    return state.filterData;
  },
);

export const getIsAddMediaEnabled = createSelector(getUserConfig, (config) => {
  return isFeatureEnabled(config, ADD_MEDIA);
});
